var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navReturn",attrs:{"id":"navReturn"}},[_c('Button',{attrs:{"slot":"left","icon":"back"},nativeOn:{"click":function($event){return _vm.goback()}},slot:"left"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }